var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoinGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Coin",
    clipPath: "url(#clip0_2239_16817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1321316605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.83087 12.7564C8.88972 12.612 8.96245 12.4736 9.04804 12.3433L9.01626 14.2501H7.75562C8.24994 13.8657 8.62321 13.3472 8.83087 12.7564Z",
    fill: "#8F939C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.91309 11.6061C8.3065 11.7862 8.68701 11.9933 9.05191 12.2258C8.88771 12.1887 8.37392 12.051 8.18323 11.9769C6.09629 11.1188 3.66506 11.6167 2.35675 11.9769L3.97757 8.83057C5.03332 10.074 6.38746 11.029 7.91309 11.6061Z",
    fill: "#8F939C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.18458 12.5272C8.46925 12.4265 8.75925 12.3417 9.05326 12.2729C8.91424 12.3686 8.765 12.4486 8.60832 12.5113C7.75479 12.8243 7.04353 13.4358 6.60613 14.2328H1.1875L2.09855 12.4583C3.30622 12.8662 5.74805 13.5601 8.18458 12.5272Z",
    fill: "#8F939C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.68837 10.8276C8.83971 11.2243 8.96186 11.6314 9.05385 12.0459V12.173C8.92143 11.9453 8.56124 11.3308 8.45531 11.0713C7.78419 9.3006 6.62312 7.75742 5.10773 6.62196L7.10462 2.75H8.41822C7.81439 4.94817 7.25823 7.90909 8.68837 10.8276Z",
    fill: "#8F939C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.4597 14.2494H9.18852L9.15674 12.3267C9.24682 12.4617 9.32312 12.6054 9.3845 12.7557C9.59581 13.3446 9.9684 13.8621 10.4597 14.2494Z",
    fill: "#8F939C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.768 11.0713C9.57595 11.4547 9.36378 11.8278 9.13239 12.1889V12.0353C9.21641 11.6223 9.33876 11.2179 9.49787 10.8276C10.9757 8.17922 10.3877 5.05411 9.76271 2.75H11.0763L13.0838 6.62726C11.5824 7.76707 10.4331 9.30744 9.768 11.0713Z",
    fill: "#8F939C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M10.3036 11.6068C11.8326 11.0382 13.191 10.0883 14.2497 8.84717L15.8758 11.9882C14.5516 11.628 12.1257 11.1407 10.0493 11.9882C9.85333 12.0676 9.31835 12.2053 9.17004 12.2424C9.53333 12.0056 9.91201 11.7932 10.3036 11.6068Z",
    fill: "#8F939C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M17.0437 14.2493H11.6145C11.1756 13.4536 10.4648 12.8425 9.61226 12.5278C9.45299 12.4614 9.30045 12.3798 9.15674 12.2842C9.45439 12.3544 9.74793 12.4411 10.036 12.5437C12.4725 13.6031 14.9197 12.8827 16.1273 12.4908L17.0437 14.2493Z",
    fill: "#8F939C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2239_16817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5,
    height: 16.5,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinGrey);
export default __webpack_public_path__ + "static/media/coin_grey.a84e2a7a2deaccf7542ebf56a838722d.svg";
export { ForwardRef as ReactComponent };